// extracted by mini-css-extract-plugin
export default {"Feedback":"feedback_Feedback__jBlSB","container":"feedback_container__W9uQQ","marquee":"feedback_marquee__Zu930"};